import type { IconButtonProps } from '@src/shared/ui/Button';
import { IconButton } from '@src/shared/ui/Button';
import { forwardRef } from 'react';

const NavIconButton = forwardRef<HTMLButtonElement, IconButtonProps>(
  (props, ref) => {
    const { children, ...rest } = props;
    return (
      <IconButton color="secondary" ref={ref} {...rest}>
        {children}
      </IconButton>
    );
  },
);

export default NavIconButton;
